import React from 'react'
import PropTypes from 'prop-types'

import { useTranslation } from 'react-i18next'

import Topics  from 'components/PackageBuilder/Results/shared/Topics'
import EventRow from './elements/EventRow'
import { SecondaryButton } from 'components/Shared/Button'

const VariationsCard = ({ result, setActiveContent, setDrawerOpen, cypressId }) => {
  const { t } = useTranslation()

  return (
    <div
      data-cy={cypressId}
      className="package-builder-page_variations-section_card_container"
    >
      <div className="package-builder-page_variations-section_card_title-row">
        <h3 className="package-builder-page_variations-section_card_title-row_headline">{result.title}</h3>

        <p className="package-builder-page_variations-section_card_title-row_customers">{t('PackageBuilder.customers')}: {result.num_customers}</p>
      </div>

      <div className="package-builder-page_variations-section_topics">
        <h6 className="package-builder-page_variations-section_card_events_title">
          {t('PackageBuilder.packageBuilderResults.topics')}
        </h6>

        <Topics keywords={result.campaign.keywords} keyPrefix={result.title} />
      </div>

      {/* _events */}
      <div className="package-builder-page_variations-section_card_events_container_wrapper">    
        <div className="package-builder-page_variations-section_card_events_container">
          <h6 className="package-builder-page_variations-section_card_events_title">
            {t('PackageBuilder.packageBuilderResults.importantEvents')}
          </h6>

          <EventRow title={result.top_event_1.title} rank={1} />

          {result.top_event_2 && result.top_event_2.title ? <EventRow title={result.top_event_2.title} rank={2} /> : null}
        
          {result.top_event_3 && result.top_event_3.title ? <EventRow title={result.top_event_3.title} rank={3} /> : null}
        </div>
        
        <SecondaryButton
          color="navy"
          size="small"
          fullWidth={false}
          onClick={() => {
            setActiveContent(result)
            setDrawerOpen(true, result.title.toLowerCase().replaceAll(' ', '-'), result)
          }}
        >
          {t('PackageBuilder.packageBuilderResults.detailsButton')}
        </SecondaryButton>
      </div>
    </div>
  )
}

VariationsCard.propTypes = {
  result: PropTypes.object.isRequired,
  setActiveContent: PropTypes.func,
  setDrawerOpen: PropTypes.func,
  cypressId: PropTypes.string,
}

export default VariationsCard
